/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addEmailRestrictions,
  getEmailRestrictions,
} from "../../../../api/User";
import { UserAtom } from "../../../../atoms/UserAtom";
import { UserEmailRestrictionsAtom } from "../../../../atoms/UserEmailRestrictionsAtom";
import { validationEmail } from "../../../../utils/Validation";
import StyledBlockInput, { BlockInputType } from "../../../StyledBlockInput";

export default function BlockEmail() {
  const [isLoading, setIsLoading] = useState(false);
  const setEmailRestrictions = useSetRecoilState(UserEmailRestrictionsAtom);
  const [user, setUser] = useRecoilState(UserAtom);

  async function handleBlockEmail(emails: string[]) {
    setIsLoading(true);

    try {
      await addEmailRestrictions({ emailsBlocked: emails });
      toast("Success", { type: "success" });
      const emailRestrictions = await getEmailRestrictions();
      setEmailRestrictions(emailRestrictions);
      setUser({ ...user, emailRestrictions });
    } catch {
      toast("Error", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <StyledBlockInput
      handleClick={handleBlockEmail}
      isLoading={isLoading}
      inputType={BlockInputType.Email}
      placeholder="Enter email"
      isValid={(value: string) => {
        const isValid = validationEmail(value);
        if (!isValid) return `${value} is not a valid email address.`;
        return "";
      }}
    />
  );
}
